import { FC, useState } from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';
import { ButtonAccent, ButtonPrimary } from '@lambdacurry/component-library';
import { DefaultLayout, ShippingAddressList, CreateShippingAddressModal } from '../../../components';

const AccountShippingAddressesPage: FC = () => {
  const [createAddressModalIsOpen, setCreateAddressModalIsOpen] = useState(false);

  return (
    <DefaultLayout title="Account - Shipping Addresses" className={classNames('account-shipping-addresses')}>
      <div className="mt-4 mb-12">
        <ButtonAccent as={buttonProps => <Link to={`/account`} {...buttonProps} />}>Back to Dashboard</ButtonAccent>
        {` `}
        <ButtonPrimary onClick={() => setCreateAddressModalIsOpen(true)} data-cy="create-shipping-address">
          Add Shipping Address
        </ButtonPrimary>
      </div>

      <ShippingAddressList />

      <CreateShippingAddressModal
        isOpen={createAddressModalIsOpen}
        onAfterClose={() => setCreateAddressModalIsOpen(false)}
      />
    </DefaultLayout>
  );
};

export default AccountShippingAddressesPage;
